/* Panier tiroir Minicar.
   Le contenu est rendu par Liquid (section minicar-cart) : apres chaque
   modification on redemande la section a Shopify (API Section Rendering)
   et on remplace l'interieur du panneau. Aucun prix n'est calcule ici. */
(function () {
  var SECTION = 'minicar-cart';
  var root, panel, busy = false;

  function q(sel, el) { return (el || root).querySelector(sel); }

  function setBusy(on) {
    busy = on;
    if (root) root.classList.toggle('is-busy', on);
  }

  function lock(on) {
    document.documentElement.style.overflow = on ? 'hidden' : '';
  }

  function open() {
    if (!root) return;
    root.classList.add('is-on');
    root.setAttribute('aria-hidden', 'false');
    lock(true);
    var x = q('[data-mcd-close]');
    if (x && x.focus) { try { x.focus({ preventScroll: true }); } catch (e) {} }
  }

  function close() {
    if (!root) return;
    root.classList.remove('is-on');
    root.setAttribute('aria-hidden', 'true');
    lock(false);
  }

  /* ---------- Rafraichissement ---------- */
  function apply(html) {
    if (!html || !panel) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('.mcd__panel');
    if (!fresh) return;
    panel.innerHTML = fresh.innerHTML;
    var n = q('[data-mcd-count]');
    var count = n && !n.hasAttribute('hidden') ? parseInt(n.textContent, 10) || 0 : 0;
    if (typeof window.mchUpdateCartBadge === 'function') window.mchUpdateCartBadge(count);
    document.dispatchEvent(new CustomEvent('mc:cart:updated', { detail: { count: count } }));
  }

  /* L'API de rendu de section doit etre appelee avec les parametres de
     l'URL courante : sans preview_theme_id, l'aperçu d'un theme non publie
     renvoie le rendu du theme EN LIGNE, qui ne contient pas cette section.
     Le tiroir restait alors sur son ancien contenu et il fallait recharger
     la page pour voir l'article ajoute. */
  function baseUrl() {
    var p = new URLSearchParams(window.location.search);
    p.delete('sections');
    p.delete('section_id');
    p.delete('_');
    var q = p.toString();
    return window.location.pathname + (q ? '?' + q : '');
  }

  function fetchSection(path) {
    var url = path + (path.indexOf('?') > -1 ? '&' : '?') + 'sections=' + SECTION + '&_=' + new Date().getTime();
    return fetch(url, { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); });
  }

  function pull() {
    return fetchSection(baseUrl())
      .then(function (j) {
        if (j && j[SECTION]) { apply(j[SECTION]); return; }
        /* Repli : la page courante ne sait pas rendre la section. */
        var p = new URLSearchParams(window.location.search);
        var t = p.get('preview_theme_id');
        return fetchSection('/' + (t ? '?preview_theme_id=' + t : ''))
          .then(function (k) { if (k && k[SECTION]) apply(k[SECTION]); });
      })
      .catch(function () {});
  }

  /* Message d'erreur (stock insuffisant, article indisponible) sous la ligne. */
  function note(key, msg) {
    if (!msg) return;
    var line = key ? q('[data-key="' + key + '"]') : null;
    var host = line ? q('.mcd-line__b', line) : q('.mcd__body');
    if (!host) return;
    var old = q('.mcd-line__err', host);
    if (old) old.remove();
    var el = document.createElement('span');
    el.className = 'mcd-line__err';
    el.textContent = msg;
    host.appendChild(el);
  }

  function post(url, body, key) {
    setBusy(true);
    body.sections = SECTION;
    body.sections_url = baseUrl();
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var msg = j && (j.description || j.message);
        if (j && j.sections && j.sections[SECTION]) { apply(j.sections[SECTION]); return; }
        return pull().then(function () { note(key, msg); });
      })
      .catch(function () { return pull(); })
      .finally(function () { setBusy(false); });
  }

  function change(key, qty) { return post('/cart/change.js', { id: key, quantity: qty }, key); }

  /* ---------- Branchements ---------- */
  function bind() {
    root = document.querySelector('[data-mcd]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    panel = q('.mcd__panel');

    root.addEventListener('click', function (e) {
      var el = e.target;

      if (el.closest('[data-mcd-close]')) { close(); return; }

      var line = el.closest('[data-mcd-line]');
      if (line && !busy) {
        var key = line.dataset.key;
        var cur = parseInt((q('[data-mcd-q]', line) || {}).textContent, 10) || 1;
        if (el.closest('[data-mcd-plus]')) { change(key, cur + 1); return; }
        if (el.closest('[data-mcd-minus]')) { change(key, cur - 1); return; }
        if (el.closest('[data-mcd-remove]')) { change(key, 0); return; }
      }

      var add = el.closest('[data-mcd-add]');
      if (add && !busy) {
        add.disabled = true;
        post('/cart/add.js', { items: [{ id: parseInt(add.dataset.mcdAdd, 10), quantity: 1 }] });
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-on')) close();
    });
  }

  /* ---------- API publique ---------- */
  window.mcdOpenCart = function () {
    if (!root) bind();
    open();
    pull();
  };
  window.mcdCloseCart = close;
  window.mcdRefreshCart = pull;

  document.addEventListener('mc:cart:added', function () {
    if (!root) bind();
    open();
    pull();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail && e.detail.sectionId === SECTION) { root = null; bind(); }
  });
})();
